<form class="modal-body oauth-client-modal" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <p class="centermodal__title">
    {{ (currentStep === ModalStep.basicInfo ? 'settings.oauthClients.basicInfo' : 'settings.oauthClients.authentication') | translate }}
  </p>
  <p class="oauth-client-modal__description">
    {{ (currentStep === ModalStep.basicInfo ? 'settings.oauthClients.basicInfoDescription' : 'settings.oauthClients.authenticationDescription') | translate }}
  </p>

  @if (currentStep === ModalStep.basicInfo) {
    <label class="field__holder full" [appFormControlWrap]="form.get('name')">
      <input type="text" class="field" formControlName="name" maxlength="40" autocomplete="none" required role="presentation" autocorrect="off" spellcheck="false" autocapitalize="off" />
      <span class="field__placeholder">{{ 'settings.oauthClients.applicationName' | translate }}</span>
    </label>

    <label class="field__holder textarea full" [appFormControlWrap]="form.get('description')">
      <textarea
        class="field oauth-client-modal__description-input"
        formControlName="description"
        maxlength="70"
        autocomplete="none"
        role="presentation"
        autocorrect="off"
        spellcheck="false"
        autocapitalize="off"
      ></textarea>
      <span class="field__placeholder">{{ 'settings.oauthClients.shortDescription' | translate }}</span>
    </label>
    <p class="oauth-client-modal__hint">{{ 'settings.oauthClients.maxCharacters' | translate: { max: 70 } }}</p>

    <div class="oauth-client-modal__icon-section">
      <p class="oauth-client-modal__section-title">{{ 'settings.oauthClients.applicationIcon' | translate }}</p>
      <p class="oauth-client-modal__section-description">{{ 'settings.oauthClients.applicationIconDescription' | translate: iconValidation }}</p>

      <app-image-input
        accept="image/png"
        [label]="'settings.oauthClients.selectImage' | translate"
        [removeLabel]="'button.remove' | translate"
        [validation]="iconValidation"
        [valueUrl]="selectedIconUrl"
        (fileChange)="selectIcon($event)"
        (remove)="removeIcon()"
        (validationError)="showIconValidationError($event)"
      ></app-image-input>
      @if (form.get('icon').invalid && form.get('icon').touched) {
        <p class="field__error-message">
          {{ form.get('icon').getError('server') || ('error_field_required' | translate) }}
        </p>
      }
    </div>
  } @else {
    <div class="oauth-client-modal__section">
      <p class="oauth-client-modal__section-title">{{ 'settings.oauthClients.oauth' | translate }}</p>
      <p class="oauth-client-modal__section-description">{{ 'settings.oauthClients.oauthDescription' | translate }}</p>
    </div>

    <div formArrayName="redirectUris">
      @if (redirectUris.at(0)) {
        <div>
          <label class="field__holder full" [appFormControlWrap]="redirectUris.at(0)">
            <input type="url" class="field" [formControlName]="0" autocomplete="none" required role="presentation" autocorrect="off" spellcheck="false" autocapitalize="off" />
            <span class="field__placeholder">{{ 'settings.oauthClients.redirectUri' | translate }}</span>
          </label>
        </div>
      }
    </div>

    @if (client?.id) {
      <div class="oauth-client-modal__client-id">
        <p class="oauth-client-modal__section-title">{{ 'settings.oauthClients.clientId' | translate }}</p>
        <button type="button" class="oauth-client-modal__client-id-value" (click)="copyClientId()" [attr.aria-label]="'button.copy' | translate">
          <span>{{ client.id }}</span>
          <i class="fa-regular fa-copy"></i>
        </button>
      </div>
    }

    <div class="oauth-client-modal__section">
      <p class="oauth-client-modal__section-title">{{ 'settings.oauthClients.permissions' | translate }}</p>
      <p class="oauth-client-modal__section-description">{{ 'settings.oauthClients.permissionsDescription' | translate }}</p>
    </div>

    <div class="oauth-client-modal__permissions" formArrayName="scopes" [loadingAnimation]="isLoadingScopes">
      @for (scope of availableScopes; track scope.id; let scopeIndex = $index) {
        <div class="oauth-client-modal__permission">
          <app-switch [formControlName]="scopeIndex"></app-switch>
          <p>{{ getScopeDescription(scope) }}</p>
        </div>
      }
      <div
        class="oauth-client-modal__permission oauth-client-modal__permission--disabled"
        [ngbTooltip]="'settings.oauthClients.restrictedScopeTooltip' | translate"
        container="body"
        placement="top-left"
      >
        <app-switch [value]="false" [disabled]="true"></app-switch>
        <p>{{ 'settings.oauthApplications.scopePermissions.documents:sign' | translate }}</p>
      </div>
      @if (!isLoadingScopes && availableScopes.length === 0) {
        <p class="oauth-client-modal__empty-permissions">{{ 'settings.oauthClients.noPermissions' | translate }}</p>
      }
    </div>
    @if (scopes.invalid && scopes.touched) {
      <p class="field__error-message">
        {{ scopes.getError('server') || ('settings.oauthClients.selectAtLeastOnePermission' | translate) }}
      </p>
    }
  }

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" [disabled]="isLoading" (click)="back()">
      {{ getSecondaryActionLabel() | translate }}
    </button>
    <button type="submit" class="btn-L btn-filled" [disabled]="isLoading || (currentStep === ModalStep.authentication && isLoadingScopes)">
      {{ getActionLabel() | translate }}
    </button>
  </div>
</form>
